<template lang="html">
  <transition name="fade">
    <div v-if="isFormSent" ref="form" :class="$style[formType]">
      <img :src="formIcon" :class="$style.formIcon" v-if="formIcon" alt="icon" />
      <h1 v-html="title" :class="$style.title" />
      <p v-html="caption" :class="$style.caption" v-if="caption" />
      <div :class="$style.telegramInfo" v-if="telegramInfo">
        <p :class="$style.text">
          Подписывайтесь на&nbsp;телеграм-канал Хантфлоу: мы&nbsp;каждый день публикуем экспертные статьи про рекрутинг
          и&nbsp;полезные подборки
        </p>
        <a :class="$style.button" :href="telegramLink" target="_blank">
          <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.82723 7.3879C7.00982 5.12993 10.4657 3.64134 12.1948 2.92212C17.1319 0.86862 18.1578 0.511905 18.8265 0.500126C18.9735 0.497535 19.3023 0.533982 19.5153 0.706816C19.6952 0.852754 19.7447 1.0499 19.7684 1.18826C19.792 1.32663 19.8215 1.64183 19.7981 1.88811C19.5305 4.6992 18.3729 11.521 17.7839 14.6694C17.5347 16.0017 17.0441 16.4484 16.569 16.4921C15.5366 16.5871 14.7527 15.8098 13.7527 15.1543C12.1881 14.1287 11.3041 13.4902 9.78534 12.4893C8.03011 11.3327 9.16795 10.6969 10.1682 9.65799C10.43 9.38609 14.9788 5.24867 15.0668 4.87335C15.0778 4.82641 15.088 4.65143 14.9841 4.55904C14.8801 4.46664 14.7267 4.49824 14.616 4.52337C14.4591 4.55898 11.9595 6.21112 7.11723 9.47978C6.40773 9.96697 5.76509 10.2044 5.1893 10.1919C4.55454 10.1782 3.33352 9.83301 2.42582 9.53795C1.31248 9.17605 0.427626 8.98471 0.504677 8.37009C0.54481 8.04996 0.985662 7.72256 1.82723 7.3879Z"
              fill="white"
            />
          </svg>
          Подписаться
        </a>
      </div>
      <button
        v-if="closeButton && !telegramInfo"
        type="button"
        class="form-success__button button button--xl js-modal-close"
      >
        {{ closeButton }}
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FormSuccessMessage',
  props: {
    formWrapperId: String,
    formId: {
      type: String,
    },
    formIcon: String,
    title: {
      type: String,
      required: true,
    },
    caption: String,
    formType: {
      type: String,
      required: true,
    },
    telegramInfo: {
      type: Boolean,
      default: true,
    },
    telegramLink: {
      type: String,
      required: true,
    },
    closeButton: String,
  },
  data: function () {
    return {
      isFormSent: false,
    };
  },
  mounted() {
    this.observeSubmit();
  },
  methods: {
    observeSubmit() {
      document.addEventListener('form-send', (e) => {
        if (e.target.id === this.formId) {
          this.isFormSent = true;

          this.$nextTick(() => {
            const formBlock = this.$refs.form?.closest('.form-block');

            if (formBlock) {
              formBlock.classList.add('is-success');
            }
          });

          if (this.formWrapperId) {
            const formWrapper = document.getElementById(this.formWrapperId);

            formWrapper.classList.add('is-success');
          }
        }
      });
    },

    show() {
      this.isFormSent = true;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;
@use '~styles/components/texts' as texts;

.caption {
  @include mixins.font(1.6rem, 1.55);

  margin: 15px auto 0;
  font-weight: vars.$fontWeightBase;

  @include mixins.media(md) {
    @include mixins.font(2.2rem, 1.46);

    max-width: 490px;
  }
}

.button {
  @include mixins.font(1.6rem, 1.3);

  display: inline-flex;
  align-items: center;
  padding: 12px 20px;
  margin-top: 24px;
  background-color: #0087b1;
  border-radius: 6px;
  color: vars.$colorBaseInverted;
  font-weight: vars.$fontWeightBase;

  @include mixins.media(md) {
    @include mixins.font(1.9rem, 1.3);

    padding: 12px 24px;
  }

  svg {
    margin-right: 8px;
  }
}

.horizontal {
  text-align: left;

  @include mixins.media(md) {
    text-align: center;
  }

  .title {
    @include mixins.font(2.3rem, 1.2);

    margin-right: -5px;
    font-weight: vars.$fontWeightSolid;
    letter-spacing: -0.015em;

    @include mixins.media(md) {
      @include mixins.font(3rem, 1.1);

      margin-right: 0;
      font-weight: vars.$fontWeightSolid;
      letter-spacing: -0.015em;
      text-align: center;
    }

    @include mixins.media(lg) {
      @include mixins.font(4rem, 1.1);

      font-weight: vars.$fontWeightSolid;
      letter-spacing: -0.015em;
    }
  }

  .text {
    @include mixins.font(1.4rem, 1.5);

    margin-top: 4px;
    font-weight: vars.$fontWeightBase;
    opacity: 0.6;

    @include mixins.media(md) {
      @include mixins.font(1.8rem, 1.45);

      max-width: 610px;
      margin: 0.8rem auto 0;
    }

    @include mixins.media(lg) {
      @include mixins.font(2.2rem, 1.4);

      max-width: 766px;
      margin: 1.2rem auto 0;
      color: vars.$colorBaseInverted;
      opacity: 0.5;
    }
  }
}

.form-section,
.form-modal {
  .telegramInfo {
    padding: 3rem;
    margin: 2rem auto -1rem;
    max-width: 320px;
    background-color: vars.$bgColorBase;
    border-radius: 16px;

    @include mixins.media(md) {
      max-width: 490px;
      padding: 4rem;
      margin: 2.8rem auto 0;
    }
  }

  .title {
    @include mixins.font(2.6rem, 1.2);

    font-weight: vars.$fontWeightBase;
    padding: 0;

    @include mixins.media(md) {
      @include mixins.font(3.9rem, 1.25);
    }

    > span {
      @include texts.text-highlight;
    }
  }

  .formIcon {
    & + .title {
      @include mixins.media(sm, max) {
        @include mixins.font(2.3rem, 1.24);
      }
    }
  }

  .text {
    @include mixins.font(1.4rem, 1.55);

    color: vars.$colorBase;
    font-weight: vars.$fontWeightLight;

    @include mixins.media(md) {
      @include mixins.font(1.8rem, 1.55);
    }
  }

  .button {
    @include mixins.media(sm, max) {
      margin-top: 16px;
    }
  }
}

.form-modal {
  text-align: center;

  .telegramInfo {
    background-color: #dcfaff;
  }

  .text {
    color: #005275;
  }
}

.premier {
  max-width: 490px;
  margin: 0 auto;

  .title,
  .caption {
    font-weight: 400;
  }

  .title {
    @include mixins.font(2.6rem, 1.2);

    margin-bottom: 1.2rem;
    letter-spacing: -0.52px;

    @include mixins.media(md) {
      @include mixins.font(3.9rem, 1.25);

      margin-bottom: 1.5rem;
      letter-spacing: -1.17px;
    }
  }

  .caption {
    @include mixins.font(1.6rem, 1.55);

    letter-spacing: -0.16px;

    @include mixins.media(md) {
      @include mixins.font(2.2rem, 1.46);

      letter-spacing: -0.22px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
